import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FromNowAsyncPipe, NgCommonModule } from '@principle-theorem/ng-shared';
import {
  IReportRun,
  ReportRunStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  DATE_WITH_YEAR,
  SHORT_DATE_TIME_FORMAT,
  toTimestamp,
  type WithRef,
} from '@principle-theorem/shared';

@Component({
  selector: 'pr-historical-run-banner',
  templateUrl: './historical-run-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIcon,
    MatTooltip,
    NgCommonModule,
    FromNowAsyncPipe,
  ],
})
export class HistoricalRunBannerComponent {
  dateFormat = DATE_WITH_YEAR;
  dateTimeFormat = SHORT_DATE_TIME_FORMAT;

  run = input.required<WithRef<IReportRun>>();
  backToCurrentReport = output<void>();
  togglePin = output<void>();
  archive = output<void>();

  isExpiringSoon = computed(() => {
    const expiresAt = this.run().expiresAt;
    if (!expiresAt) {
      return false;
    }
    return expiresAt.toMillis() <= toTimestamp().toMillis();
  });

  runPinnedTooltip = computed(() => {
    return this.run().pinned
      ? 'This run is pinned and will not be automatically cleaned up'
      : 'Pin this run to prevent automatic cleanup after 30 days';
  });

  isComplete(run: WithRef<IReportRun>): boolean {
    return run.status === ReportRunStatus.Complete;
  }
}
